<template>
    <div>

        <WhatsappWeb :suggestedPhone="$store.state.businessSettings.phone"></WhatsappWeb>


        <br>
        <br>
        <br>


        <h5>
            תור הודעות שלא נשלחו
        </h5>

        <div style="color:#777;font-size:13px;">
            הודעות ואצאפ שלא הצליחו להישלח (למשל כשהחשבון לא היה מחובר) נשמרות כאן,
            וניתן לשלוח אותן מחדש. ההודעות נשלחות בהפרש של כמה שניות זו מזו כדי שהחשבון לא ייחסם.
        </div>

        <br>

        <div v-if="!queuedMessages.length"
             style="color:#999;">
            <i class="fa-regular fa-circle-check"></i>
            &nbsp;
            אין הודעות שממתינות לשליחה
        </div>


        <template v-else>

            <table class="table table-hover"
                   style="max-width:1000px;">
                <thead>
                    <tr>
                        <th style="width:120px;">תאריך</th>
                        <th style="width:170px;">נמען</th>
                        <th>הודעה</th>
                        <th style="width:200px;">שגיאה</th>
                        <th style="width:40px;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="queuedMessage in queuedMessages"
                        :key="queuedMessage.id">

                        <td style="font-size:13px;color:#777;">
                            {{ formatDate(queuedMessage.created) }}
                        </td>

                        <td>
                            <router-link v-if="queuedMessage.customerId"
                                         :to="`/customers/${queuedMessage.customerId}`">
                                {{ recipientName(queuedMessage) }}
                            </router-link>
                            <span v-else>
                                {{ recipientName(queuedMessage) }}
                            </span>
                        </td>

                        <td>
                            <div :title="queuedMessage.message"
                                 style="max-width:340px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                                {{ queuedMessage.message }}
                            </div>
                        </td>

                        <td style="font-size:12px;color:#b82e24;">
                            <div :title="queuedMessage.error"
                                 style="max-width:200px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                                {{ queuedMessage.error }}
                            </div>
                            <span v-if="queuedMessage.attempts > 0"
                                  style="color:#999;">
                                ({{ queuedMessage.attempts }} ניסיונות שליחה)
                            </span>
                        </td>

                        <td>
                            <i class="fa-regular fa-trash-can trashButton"
                               style="cursor:pointer;color:#999"
                               @click="deleteQueuedMessage(queuedMessage)"></i>
                        </td>

                    </tr>
                </tbody>
            </table>


            <button class="btn btn-primary"
                    :disabled="sending"
                    @click="sendQueuedMessages">
                <i class="fa-brands fa-whatsapp"></i>
                &nbsp;
                <span v-if="!sending">שלח את ההודעות שבתור ({{ queuedMessages.length }})</span>
                <span v-else>
                    <i class="fa-solid fa-spinner fa-spin"></i>
                    &nbsp;
                    שולח... נותרו {{ queuedMessages.length }}
                </span>
            </button>

            <span v-if="$store.state.whatsappConnected === false && !sending"
                  style="color:#b82e24;font-size:13px;margin-right:10px;">
                שימו לב: החשבון מנותק כרגע - כדאי לחבר אותו לפני השליחה
            </span>

        </template>


    </div>
</template>
<script>

import axiosV2, { apiPost, apiDelete } from '../../../core/http/axios_api_v2';
import WhatsappWeb from '../WhatsappWeb.vue';

export default {
    name: 'WhatsappTab',
    components: {
        WhatsappWeb
    },
    data() {
        return {
            queuedMessages: [],
            sending: false,
            pollInterval: null
        }
    },
    created() {

        this.refresh();

        //the settings page keeps every tab-pane mounted, so poll gently: it keeps the list
        //live while a background flush drains the queue (and after a reconnect popup flush)
        this.pollInterval = setInterval(this.refresh, 5000);

        this.$root.$on('whatsappQueueFlushStarted', this.refresh);

    },
    beforeDestroy() {
        clearInterval(this.pollInterval);
        this.$root.$off('whatsappQueueFlushStarted', this.refresh);
    },
    methods: {

        refresh() {

            axiosV2('whatsapp/queuedMessages').then(res => {

                let data = (res && res.data) || {};
                let wasSending = this.sending;

                this.queuedMessages = data.messages || [];
                this.sending = !!data.sending;

                //a flush just finished — tell the user how it went
                if (wasSending && !this.sending) {

                    if (!this.queuedMessages.length) {
                        this.$notify({
                            type: 'success',
                            title: 'כל ההודעות נשלחו',
                            text: 'תור ההודעות ריק'
                        });
                    } else {
                        this.$notify({
                            type: 'error',
                            title: 'לא כל ההודעות נשלחו',
                            text: 'חלק מההודעות נשארו בתור - בדקו שהחשבון מחובר ונסו שוב'
                        });
                    }

                }

            }).catch(() => { });

        },

        sendQueuedMessages() {

            apiPost('whatsapp/sendQueuedMessages', {}, true).then(data => {

                if (data && data.started) {
                    this.sending = true;
                    this.$notify({
                        type: 'success',
                        title: 'שליחת ההודעות החלה',
                        text: 'ההודעות נשלחות ברקע בהפרשים קטנים'
                    });
                }

                this.refresh();

            });

        },

        deleteQueuedMessage(queuedMessage) {

            if (!confirm('למחוק את ההודעה מהתור? היא לא תישלח.'))
                return;

            apiDelete(`whatsapp/queuedMessages/${queuedMessage.id}`, {}, true).then(() => {
                this.queuedMessages = this.queuedMessages.filter(qm => qm.id != queuedMessage.id);
            });

        },

        recipientName(queuedMessage) {

            let name = `${queuedMessage.firstName || ''} ${queuedMessage.lastName || ''}`.trim();

            if (name && queuedMessage.phone)
                return `${name} (${queuedMessage.phone})`;

            return name || queuedMessage.phone || '';

        },

        formatDate(dateString) {

            if (!dateString)
                return '';

            let date = new Date(dateString);

            if (isNaN(date.getTime()))
                return dateString;

            let dd = ('0' + date.getDate()).slice(-2);
            let mm = ('0' + (date.getMonth() + 1)).slice(-2);
            let hh = ('0' + date.getHours()).slice(-2);
            let min = ('0' + date.getMinutes()).slice(-2);

            return `${dd}/${mm}/${date.getFullYear()} ${hh}:${min}`;

        }

    }
}
</script>
